module.exports = __webpack_public_path__ + "static/media/gallery-27.1d09d5cc.jpg";